import React from 'react'
//Helpers
import { RealEstateDataPageComponentData } from 'types'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import { getLastVideo, getVideo } from '@helpers/helper.properties'
import { Container } from 'react-bootstrap'
import './index.scss'

interface ExternalProps {
  developmentID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const DevelopmentVideos_1 = ({
  developmentID,
  global_data,
  upperCaseLink,
  alignCenter,
  titleSecondary,
}: CombinedProps) => {
  const { data: allDevelopmentData, isLoading } = useQueryDevelopment(
    developmentID,
    global_data.pageConfig.keys.tokko,
  )

  return (
    getLastVideo(allDevelopmentData) && (
      <section
        className="p-y-config development-videos a"
        id="Videos"
      >
        <Container fluid>
          <h2
            className={
              'mb-lg-5 mb-5 ' +
              (upperCaseLink ? ' text-uppercase ' : '') +
              (alignCenter ? ' text-center' : '') +
              (titleSecondary ? ' secondary-color' : '')
            }
          >
            {getLastVideo(allDevelopmentData)?.title || 'Video'}
          </h2>
          <iframe
            className={'iframe-width'}
            src={getLastVideo(allDevelopmentData)?.player_url}
          />
        </Container>
      </section>
    )
  )
}

export default DevelopmentVideos_1
